import {
  Slider,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";

interface CustomProps {
  contacts: number;
  setContacts: Function;
  currency: string;
  setCurrency: Function;
  marks: any;
  currencies: any;
  currentSubscribers: number;
}

const ContactLimitSlider = (props: CustomProps) => {
  const {
    contacts,
    setContacts,
    currency,
    setCurrency,
    marks,
    currencies,
    currentSubscribers,
  } = props;

  const handleChange = (
    event: Event,
    value: number | number[],
    activeThumb: number
  ) => {
    const newValue = Array.isArray(value) ? value[0] : value;

    const minSelectable = Math.min(
      contacts,
      Math.max(
        currentSubscribers,
        Math.min(
          ...marks
            .map((m: any) => m.value)
            .filter((v: any) => v >= currentSubscribers)
        )
      )
    );

    const maxSelectable = Math.max(...marks.map((m: any) => m.value));
    const clamped = Math.max(minSelectable, Math.min(newValue, maxSelectable));

    const closestMark = marks.reduce((prev: any, curr: any) =>
      Math.abs(curr.value - clamped) < Math.abs(prev.value - clamped)
        ? curr
        : prev
    );
    setContacts(closestMark.value);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={3}
    >
      <Slider
        value={contacts}
        onChange={handleChange}
        min={marks[0].value}
        max={marks[marks.length - 1].value}
        step={null}
        marks={marks.map((mark: any) => ({ ...mark, label: "" }))}
        valueLabelDisplay="on"
        valueLabelFormat={(value) => value.toLocaleString()}
        sx={{
          color: "#EFF0F6",
          height: 8,
          "& .MuiSlider-thumb": {
            backgroundColor: "#fff",
            border: "1px solid #D9DBE9",
            width: 18,
            height: 18,
          },
          "& .MuiSlider-track": {
            backgroundColor: "#7551D0",
            borderRadius: "10px",
          },
          "& .MuiSlider-rail": {
            backgroundColor: "#EFF0F6",
            opacity: 1,
            borderRadius: "10px",
          },
          "& .MuiSlider-mark": {
            backgroundColor: "#7551D0",
            height: 3,
            width: 3,
            borderRadius: "50%",
          },
          "& .MuiSlider-valueLabel": {
            lineHeight: 1.2,
            fontSize: 12,
            padding: 1,
            borderRadius: "20px",
            backgroundColor: "#7551D0",
            "&::before": {
              display: "none",
            },
          },
        }}
      />
      {currencies?.includes("INR") && (
        <Stack>
          <Select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            size="small"
            sx={{
              "& .MuiSelect-select": {
                background: "#EBE6F8",
                borderRadius: "12px",
                color: "#7551D0",
              },
              "& .MuiSelect-icon": {
                color: "#7551D0",
              },
            }}
          >
            {currencies?.map((item: string, index: number) => (
              <MenuItem key={index} value={item}>
                {item === "USD" ? "$" : item === "INR" ? "₹" : ""} {item}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      )}
    </Stack>
  );
};

export default ContactLimitSlider;
